import { CommonModule } from '@angular/common';
import * as i0 from "@angular/core";
export class StatusBarModule {
}
StatusBarModule.ɵfac = function StatusBarModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StatusBarModule)(); };
StatusBarModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: StatusBarModule });
StatusBarModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
